import { render, staticRenderFns } from "./InvoiceStavkaEdit.vue?vue&type=template&id=34338624"
import script from "./InvoiceStavkaEdit.vue?vue&type=script&lang=js"
export * from "./InvoiceStavkaEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports